// Shim for react-dom to provide findDOMNode compatibility with React 19
// (webpack aliases react-dom$ here for third-party libraries that still call it)
import * as ReactDOM from '../node_modules/react-dom/index.js';

// Polyfill findDOMNode for React 19 compatibility
const findDOMNode = (componentOrElement: any): Element | null => {
	if (componentOrElement == null) {
		return null;
	}
	if (componentOrElement.nodeType === 1) {
		return componentOrElement;
	}
	// Try to get the DOM node from React fiber
	if (componentOrElement._reactInternals) {
		const fiber = componentOrElement._reactInternals;
		let node = fiber;
		while (node) {
			if (node.stateNode && node.stateNode.nodeType === 1) {
				return node.stateNode;
			}
			if (node.child) {
				node = node.child;
			} else if (node.sibling) {
				node = node.sibling;
			} else {
				while (node && !node.sibling && node.return) {
					node = node.return;
				}
				if (node) {
					node = node.sibling;
				}
			}
		}
	}
	return null;
};

const reactDOMWithFindDomNode = Object.assign({}, ReactDOM, { findDOMNode });

// Export a local react-dom wrapper with findDOMNode without mutating the ESM namespace.
export default reactDOMWithFindDomNode;
export * from '../node_modules/react-dom/index.js';
export { findDOMNode };
